import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-234b6cd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tpd-content-layout" }
const _hoisted_2 = { class: "tpd-content-box pb-30" }
const _hoisted_3 = { class: "faqs-header mb-40" }
const _hoisted_4 = { class: "faqs-main-title mb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-question me-2 text-primary" }, null, -1 /* HOISTED */))
const _hoisted_6 = { class: "faqs-subtitle mb-0" }
const _hoisted_7 = {
  key: 0,
  class: "faqs-loading text-center py-5"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1 /* HOISTED */))
const _hoisted_9 = { class: "mt-3 text-muted" }
const _hoisted_10 = { class: "faqs-empty text-center py-5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "faqs-empty-icon mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-folder-open fa-3x text-muted" })
], -1 /* HOISTED */))
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "text-muted" }
const _hoisted_14 = { class: "faqs-all-sections" }
const _hoisted_15 = { class: "faqs-section-header mb-15" }
const _hoisted_16 = { class: "d-flex align-items-center gap-3" }
const _hoisted_17 = { class: "faqs-section-icon" }
const _hoisted_18 = { class: "faqs-section-title mb-0" }
const _hoisted_19 = { class: "faqs-card" }
const _hoisted_20 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Header "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Frequently Asked Questions')), 1 /* TEXT */)
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString($setup.lms_website.__('Find answers to the most common questions below.')), 1 /* TEXT */)
      ]),
      _createCommentVNode(" Loading State "),
      ($data.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("p", _hoisted_9, _toDisplayString($setup.lms_website.__('Loading FAQs...')), 1 /* TEXT */)
          ]))
        : ($options.categories.length === 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Empty State "),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("h5", _hoisted_12, _toDisplayString($setup.lms_website.__('No FAQs available at the moment.')), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_13, _toDisplayString($setup.lms_website.__('Please check back later.')), 1 /* TEXT */)
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" All FAQ Sections "),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.categories, (category, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["faqs-section", { 'mb-30': index < $options.categories.length - 1 }])
                  }, [
                    _createCommentVNode(" Section Header "),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("i", {
                            class: _normalizeClass(category.icon)
                          }, null, 2 /* CLASS */)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("h5", _hoisted_18, _toDisplayString(category.label), 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    _createCommentVNode(" Section Content Card "),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", {
                        class: "faqs-card-body",
                        innerHTML: category.content
                      }, null, 8 /* PROPS */, _hoisted_20)
                    ])
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    ])
  ]))
}